import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  useTheme,
  useMediaQuery,
  Typography
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { green } from '@material-ui/core/colors';
import { STATUS_API } from 'src/app/constant/config';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { extendService } from 'src/features/deviceSlice';
import CustomDialog from 'src/app/components/CustomDialog';
import { getRemainingDays } from 'src/app/utils/commomService';

function ExtendService({ open, onClose, device, devices = [] }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const statusextendService = useSelector(state => state.deviceSlice.statusextendService);

  const targetDevices = devices.length > 0 ? devices : (device ? [device] : []);
  const targetDevice = targetDevices[0] || {};
  const serialsText = targetDevices.map(d => d.serial || d.imei || d.id).filter(Boolean).join(', ');
  const daysRemain = getRemainingDays(targetDevice?.subscription?.end);

  const handleSubmit = async data => {
    const days = Number(data.days);
    if (isNaN(days)) return;

    try {
      await Promise.all(
        targetDevices.map(d =>
          dispatch(
            extendService({
              data: { days },
              id: d.id
            })
          )
        )
      );
    } catch (err) {
      console.error('Gia hạn dịch vụ thất bại:', err);
    }
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <CustomDialog title="Gia hạn dịch vụ" open={open} onClose={handleClose} >
      <Formik
        initialValues={{
          serial: serialsText,
          days: Number(daysRemain) || 365
        }}
        enableReinitialize={true}
        validationSchema={Yup.object().shape({
          days: Yup.number()
            .required('Vui lòng nhập số ngày gia hạn')
        })}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item md={12} xs={12}>
                <InputLabel>
                  Serial thiết bị <span style={{ color: 'red' }}></span>
                </InputLabel>
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  disabled={true}
                  helperText={touched.email && errors.email}
                  margin="normal"
                  className="input-no-fieldset"
                  name="email"
                  size="small"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.serial}
                  variant="outlined"
                />
              </Grid>

              <Grid item md={12} xs={12}>
                <InputLabel>
                  Số ngày gia hạn <span style={{ color: 'red' }}></span>
                </InputLabel>
                <TextField
                  error={Boolean(touched.days && errors.days)}
                  className="input-no-fieldset"
                  fullWidth
                  helperText={touched.days && errors.days}
                  margin="normal"
                  name="days"
                  size="small"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.days}
                  variant="outlined"
                />
              </Grid>

            </Grid>
            <Box my={3}>
              <div className={classes.groupButtonSubmit}>
                <div className={classes.wrapper}>
                  <Button
                    style={{
                      ...(isMobile && { maxWidth: 90 }),
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                    onClick={() => onClose()}
                    className="btn-main btn-plain mx-3"
                    color="primary"
                    size="large"
                    variant="contained"
                  >
                    Thoát
                  </Button>
                  <Button
                    style={{
                      ...(isMobile && { maxWidth: 120 }),
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                    className="btn-main mx-3"
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Lưu lại
                  </Button>
                  {statusextendService === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              </div>
            </Box>
          </form>
        )}
      </Formik>
    </CustomDialog>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    },
  }
}));

export default React.memo(ExtendService);
